import { render, staticRenderFns } from "./ActivitiesTable.vue?vue&type=template&id=31afdc71&"
import script from "./ActivitiesTable.vue?vue&type=script&lang=js&"
export * from "./ActivitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports